import React from 'react';

export const LinkedinIcon = ({ id, props, isPreview, t }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-labelledby={'svg' + id}
    {...props}
  >
    <title id={'svg' + id}>
      {isPreview ? t('social.icons.disablePreviewMode') : 'Linkedin'}
    </title>
    <g>
      <path
        d="M17.635 17.634h-2.372V13.92c0-.885-.016-2.024-1.234-2.024-1.235 0-1.423.965-1.423 1.96v3.778h-2.372V9.998h2.276v1.044h.033c.316-.6 1.09-1.233 2.245-1.233 2.403 0 2.847 1.58 2.847 3.637v4.188zM7.558 8.955a1.376 1.376 0 11.001-2.751 1.376 1.376 0 01-.001 2.751zm-1.187 8.679h2.374V9.998H6.371v7.636zM18.817 4H5.18C4.53 4 4 4.517 4 5.154v13.692C4 19.483 4.53 20 5.18 20h13.637c.652 0 1.183-.517 1.183-1.154V5.154C20 4.517 19.47 4 18.817 4z"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
